import { AwsConfig as AwsConstants } from '@services/Constants';

import BaseService, { RequestInterface } from '@services/Base';
import IProcessValue from '@components/FormFlow/Interfaces/IProcessValue';
import { PillarNames } from '@interfaces/pillar';

export default class ProcessValueService extends BaseService {
    constructor(pillar: PillarNames) {
        switch (pillar) {
            case PillarNames.EHSS:
                super(AwsConstants.API_EHSS, 'process-value');
                break;
            case PillarNames.LI:
            default:
                super(AwsConstants.API_LI, 'process-value');
                break;
        }
    }


    async processExec(unitId: string, eventId: string, data: IProcessValue): Promise<void> {
        const params: RequestInterface = {
            queryStringParameters: { unit: unitId, eventId: eventId, },
            body: data
        };
        const res = await super.post<void>('done/', params);
        return res;

    }
}